module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART ONE: EXCERPTS FROM THE NOVELS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01chapter01"
    }
  }, [_c('strong', [_c('em', [_vm._v("Ringworld’s Children")])]), _vm._v(" (Chapters 1 and 2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01chapter02"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("Svetz and the Beanstalk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part01chapter03"
    }
  }, [_c('strong', [_c('em', [_vm._v("Rainbow Mars")])]), _vm._v(" (Chapters 18 and 19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("Escape from Hell")])]), _vm._v(","), _c('br'), _vm._v("    by Larry Niven and Jerry Pournelle")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Escape from Hell")])]), _vm._v(" (Seventh Circle, Third Round)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("Burning Tower")])]), _vm._v(","), _c('br'), _vm._v("    by Larry Niven and Jerry Pournelle")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Burning Tower")])]), _vm._v(" (Chapters 2 and 3)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("Building Harlequin’s Moon")])]), _vm._v(","), _c('br'), _vm._v("    by Larry Niven and Brenda Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Building Harlequin’s Moon")])]), _vm._v(" (Chapter 12)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Larry Niven’s description of genesis for "), _c('em', [_vm._v("Fleet of Worlds")])]), _vm._v(","), _c('br'), _vm._v("    by Larry Niven and Edward M. Lerner")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Fleet of Worlds")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("Juggler of Worlds")])]), _vm._v(","), _c('br'), _vm._v("    by Larry Niven and Edward M. Lerner")]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Juggler of Worlds")])]), _vm._v(" (edited version of Chapter 59)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART TWO: STORIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to “Choosing Names”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Choosing Names”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to “Fly-by-Night”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Fly-by-Night”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to “The Hunting Park”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“The Hunting Park”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“After Mecca”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Cadet Amelia”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Cat Toy”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Chicxulub”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“The Gatherers’ Guild”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“The Solipsist at Dinner”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Boys and Girls Together”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART THREE: NONFICTION FOR SPACE.COM")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Traveler”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Rocket Men”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Wet Mars”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART FOUR: COLLABORATION WITH JERRY POURNELLE AND STEVEN BARNES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("Beowulf’s Children")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Beowulf’s Children")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART FIVE: COLLABORATION WITH JERRY POURNELLE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part05chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Where Next, Columbus?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART SIX: COLLABORATION WITH STEVEN BARNES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part06chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to "), _c('em', [_vm._v("Achilles’ Choice")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part06chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Achilles’ Choice")])]), _vm._v(" (Chapters 15 and 16)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part07",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART SEVEN: COLLABORATIONS WITH BRENDA COOPER")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part07chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part07chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Choosing Life”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part07chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Free Floaters”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part07chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Finding Myself”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part08",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART EIGHT: DRACO TAVERN STORIES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part08chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to “The Missing Mass”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part08chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“The Missing Mass”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part08chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction to “Safe Harbor”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part08chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Safe Harbor”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part09",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART NINE: MISCELLANEOUS NONFICTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part09chapter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Hooking the Reader")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part09chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Larry Niven Interview")])]), _vm._v(" "), _c('strong', [_vm._v("by Brenda Cooper in 2000 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part09chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Food Story for the Con Jose Program Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part09chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("“Inconstant Moon Has Passed”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0